import { render, staticRenderFns } from "./DonorName.vue?vue&type=template&id=a1763004&"
import script from "./DonorName.vue?vue&type=script&lang=js&"
export * from "./DonorName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports